module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[73]72.0b13db7.woff2";